import velocity from 'velocity-animate';
import Notifications from 'vue-notification';
import Vue from 'vue';
import Vuetify from 'vuetify';
import { Autocomplete } from 'element-ui';
import Tooltip from 'vue-directive-tooltip';
import VueTheMask from 'vue-the-mask';
import ru from 'vuetify/src/locale/ru.ts';
// import VueYandexMetrika from 'vue-yandex-metrika';
import YmapPlugin from 'vue-yandex-maps';
import ImageUploader from 'vue-image-upload-resize';
import { dom, library } from '@fortawesome/fontawesome-svg-core';
import {
  faAddressCard,
  faAngleDoubleDown,
  faAngleDown,
  faAngleUp,
  faArrowDown,
  faArrowLeft,
  faArrowUp,
  faBars,
  faBell,
  faBookOpen,
  faBookReader,
  faChalkboardTeacher,
  faChartBar,
  faClipboardCheck,
  faClipboardList,
  faCloudDownloadAlt,
  faComment,
  faCommentAlt,
  faCommentDots,
  faComments,
  faEdit,
  faEye,
  faFileAlt,
  faFileInvoiceDollar,
  faFilePdf,
  faFlag,
  faGift,
  faHome,
  faKiwiBird,
  faMobileAlt,
  faNewspaper,
  faPaperPlane,
  faPlusCircle,
  faQuestionCircle,
  faRubleSign,
  faSave,
  faShoppingBasket,
  faShoppingCart,
  faSignInAlt,
  faSignOutAlt,
  faTimes,
  faTimesCircle,
  faTrashAlt,
  faUserCircle,
  faUserEdit,
  faUserGraduate,
  faUserShield,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
// import colors from 'vuetify/lib/util/colors';
import router from './routes';
import store from './store/storage';
import App from './app/App.vue';
import 'vuetify/dist/vuetify.min.css';
import 'vue-directive-tooltip/dist/vueDirectiveTooltip.css';
import 'element-ui/lib/theme-chalk/index.css';
import './assets/scss/main.scss';

// import FontAwesome icons
library.add(
  faRubleSign,
  faUserCircle,
  faQuestionCircle,
  faNewspaper,
  faHome,
  faGift,
  faFileAlt,
  faChalkboardTeacher,
  faShoppingCart,
  faUserGraduate,
  faComments,
  faUserShield,
  faSignInAlt,
  faSignOutAlt,
  faShoppingBasket,
  faCloudDownloadAlt,
  faBell,
  faFilePdf,
  faPaperPlane,
  faClipboardList,
  faTrashAlt,
  faBookReader,
  faBookOpen,
  faEdit,
  faUserEdit,
  faPlusCircle,
  faClipboardCheck,
  faAngleDoubleDown,
  faEye,
  faComment,
  faArrowLeft,
  faArrowDown,
  faArrowUp,
  faAddressCard,
  faSave,
  faTimesCircle,
  faTimes,
  faChartBar,
  faBars,
  faCommentDots,
  faCommentAlt,
  faAngleDown,
  faAngleUp,
  faFileInvoiceDollar,
  faKiwiBird,
  faMobileAlt,
  faFlag,
);
dom.i2svg();

// Vue plugins
Vue.use(Vuetify);
Vue.use(Tooltip);
Vue.use(VueTheMask);
Vue.use(Autocomplete);
Vue.use(Notifications, { velocity });
Vue.use(ImageUploader);
Vue.component('font-awesome-icon', FontAwesomeIcon);
Vue.config.productionTip = false;
Vue.use(YmapPlugin);
// Vue.use(VueYandexMetrika, {
//   id: 87188632,
//   router,
//   env: process.env.NODE_ENV,
// });

/* eslint-disable no-new */
new Vue({
  vuetify: new Vuetify({
    lang: {
      locales: { ru },
      current: 'ru',
    },
    theme: {
      themes: {
        light: {
          primary: '#005B99',
          secondary: '#00A5DB',
          accent: '#F28411',
          error: '#D81E05',
        },
        dark: {
          primary: '#005B99',
        },
      },
    },
  }),
  store,
  router,
  render: h => h(App),
  async created() {
    this.$store.commit('SetLoading', false);
    await this.$store.dispatch('GetProfile');
  },
}).$mount('#app');

new Vue({
  store,
  computed: {
    myFavicon() {
      return this.$store.state.settings.faviconUrl;
    },
  },
}).$mount('.favicon');
